import axios from "axios";
import { DmsUserDataReq } from "../schemas/dms.shema";

export function putInsertOrUpdateDmsUser(body: DmsUserDataReq) {
    return axios.put<string>('/v1/user/update/dms', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}